import React from 'react'
import { Link } from 'react-router-dom'
import {
    COLOR_KEYS,
    CreatorSettingColorType,
} from '../../../../hook/creator/useCreatorSettingColor'
import { formatDateTime } from '../../../../utils/filters'
import { DATE_FORMAT } from '../../../../utils/constant'

type newsIndexItemProps = {
    news: any
    settingColor: CreatorSettingColorType
}

function NewsCarouselItem({
    news,
    settingColor,
}: newsIndexItemProps): JSX.Element {
    return (
        <Link to={news.url}>
            <div
                className="overflow-hidden rounded-xl border shadow-md transition mb-12 sm:mb-6 mx-1 sm:mx-2"
                style={{
                    color:
                        settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]
                            ?.hex ?? '',
                    borderColor:
                        settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]
                            ?.hex ?? '',
                }}
            >
                <div className="px-4 py-4 ps-4 pe-4">
                    <p className="font- semiboldhover:text-blue-900 text-lg">
                        {news.title}
                    </p>
                    <p className="mt-1">
                        {formatDateTime(news.publish_at)(DATE_FORMAT)}
                    </p>
                </div>
            </div>
        </Link>
    )
}

export default NewsCarouselItem
